import { useEffect, useState } from 'react';
import { PlansListResponseDto } from '@tiendanube/common';
import { useShouldScheduleDowngrade } from 'domains/Billing/BillingPlans/hooks';
import { trackingBillingDowngradeFreePlan } from 'domains/Billing/tracking';
import {
  DowngradeBasicPlanModal,
  DowngradePlanModal,
  UpgradePlanModal,
} from './components';
import { ChangeType } from '../../BillingPlansPage';

export interface ChangePlanModalProps {
  show: boolean;
  changeType?: ChangeType;
  onConfirm: () => void;
  onCancel: () => void;
  currentPlan?: PlansListResponseDto;
  newPlan?: PlansListResponseDto;
}

function ChangePlanModal(props: Readonly<ChangePlanModalProps>) {
  const { changeType, show, onConfirm, newPlan, currentPlan } = props;
  const [disableConfirm, setDisableConfirm] = useState(false);
  const { shouldScheduleDowngrade } = useShouldScheduleDowngrade();

  const handleOnConfirm = () => {
    if (changeType === 'downgrade' || changeType === 'basic')
      trackingBillingDowngradeFreePlan({
        currentPlan: currentPlan?.name || '',
        newPlan: newPlan?.name || '',
        scheduled: shouldScheduleDowngrade,
      });
    setDisableConfirm(true);
    onConfirm();
  };

  useEffect(() => {
    if (show) setDisableConfirm(false);
  }, [show]);

  switch (changeType) {
    case 'upgrade':
      return (
        <UpgradePlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={disableConfirm}
        />
      );
    case 'basic':
      return (
        <DowngradeBasicPlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={disableConfirm}
        />
      );
    case 'downgrade':
      return (
        <DowngradePlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={disableConfirm}
        />
      );
    default:
      return null;
  }
}

export default ChangePlanModal;
